{
  "title": "Spike Growth",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (seven sharp thorns or seven small twigs, each sharpened to a point)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "The ground in a 20-foot radius centered on a point within range twists and sprouts hard spikes and thorns. The area becomes difficult terrain for the duration. When a creature moves into or within the area, it takes 2d4 piercing damage for every 5 feet it travels.",
    "The transformation of the ground is camouflaged to look natural. Any creature that can’t see the area at the time the spell is cast must make a Wisdom (Perception) check against your spell save DC to recognize the terrain as hazardous before entering it."
  ],
  "spellLists": ["druid", "ranger"]
}
